import { render, staticRenderFns } from "./RegForm.vue?vue&type=template&id=26d4d75a&scoped=true&"
import script from "./RegForm.vue?vue&type=script&lang=js&"
export * from "./RegForm.vue?vue&type=script&lang=js&"
import style0 from "./RegForm.vue?vue&type=style&index=0&id=26d4d75a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d4d75a",
  null
  
)

export default component.exports